import { StyleSheet, Text, View } from "@react-pdf/renderer"
import PropTypes from "prop-types"
import React from "react"

const styles = StyleSheet.create({
  label: {
    fontFamily: 'Helvetica-Bold',
    marginRight: 4,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: 4,
  },
})

export const Label = ({ text }) => (
  <Text style={styles.label}>{text}</Text>
)

Label.propTypes = {
  text: PropTypes.string.isRequired,
}

export const DataField = ({ label, value, style, containerStyle, flexible }) => (
  <View style={[styles.container, containerStyle]}>
    <Label text={label} />
    <Text style={{ ...(flexible ? { flex: 1 } : {}), ...style }}>{value}</Text>
  </View>
)


DataField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  style: PropTypes.object,
  flexible: PropTypes.bool,
  containerStyle: PropTypes.object,
}

DataField.defaultProps = {
  value: '',
  style: {},
  containerStyle: {},
  flexible: true,
}

export default Label
